// Telefon girişi için ülke kodu listesi — TR ilk sırada/varsayılan.
// Tüm dünya (~195 ülke) yerine HepyApp'in gerçekçi müşteri/tedarikçi coğrafyasına göre
// öncelikli bir alt küme: AB, ABD/Kanada, UK, Körfez, Balkanlar, Türk cumhuriyetleri.
// uzunluk: ülke kodundan sonraki (yerel, başındaki "0" olmadan) standart hane sayısı —
// input mask'te hem "daha fazla rakam kabul etme" sınırı hem de format ipucu için kullanılır.
export const ULKE_KODLARI = [
  { ad: "Türkiye", dial: "+90", uzunluk: 10 },
  { ad: "Almanya", dial: "+49", uzunluk: 11 },
  { ad: "Amerika Birleşik Devletleri", dial: "+1", uzunluk: 10 },
  { ad: "Avustralya", dial: "+61", uzunluk: 9 },
  { ad: "Azerbaycan", dial: "+994", uzunluk: 9 },
  { ad: "Belçika", dial: "+32", uzunluk: 9 },
  { ad: "Birleşik Arap Emirlikleri", dial: "+971", uzunluk: 9 },
  { ad: "Birleşik Krallık", dial: "+44", uzunluk: 10 },
  { ad: "Bosna Hersek", dial: "+387", uzunluk: 8 },
  { ad: "Bulgaristan", dial: "+359", uzunluk: 9 },
  { ad: "Danimarka", dial: "+45", uzunluk: 8 },
  { ad: "Fransa", dial: "+33", uzunluk: 9 },
  { ad: "Gürcistan", dial: "+995", uzunluk: 9 },
  { ad: "Hırvatistan", dial: "+385", uzunluk: 9 },
  { ad: "Hollanda", dial: "+31", uzunluk: 9 },
  { ad: "Irak", dial: "+964", uzunluk: 10 },
  { ad: "İran", dial: "+98", uzunluk: 10 },
  { ad: "İspanya", dial: "+34", uzunluk: 9 },
  { ad: "İsveç", dial: "+46", uzunluk: 9 },
  { ad: "İsviçre", dial: "+41", uzunluk: 9 },
  { ad: "İtalya", dial: "+39", uzunluk: 10 },
  { ad: "Kanada", dial: "+1", uzunluk: 10 },
  { ad: "Katar", dial: "+974", uzunluk: 8 },
  { ad: "Kazakistan", dial: "+7", uzunluk: 10 },
  { ad: "Kosova", dial: "+383", uzunluk: 8 },
  { ad: "Kuveyt", dial: "+965", uzunluk: 8 },
  { ad: "Kuzey Kıbrıs", dial: "+90", uzunluk: 10 },
  { ad: "Kuzey Makedonya", dial: "+389", uzunluk: 8 },
  { ad: "Kırgızistan", dial: "+996", uzunluk: 9 },
  { ad: "Lübnan", dial: "+961", uzunluk: 8 },
  { ad: "Mısır", dial: "+20", uzunluk: 10 },
  { ad: "Norveç", dial: "+47", uzunluk: 8 },
  { ad: "Özbekistan", dial: "+998", uzunluk: 9 },
  { ad: "Polonya", dial: "+48", uzunluk: 9 },
  { ad: "Portekiz", dial: "+351", uzunluk: 9 },
  { ad: "Romanya", dial: "+40", uzunluk: 9 },
  { ad: "Rusya", dial: "+7", uzunluk: 10 },
  { ad: "Suudi Arabistan", dial: "+966", uzunluk: 9 },
  { ad: "Sırbistan", dial: "+381", uzunluk: 9 },
  { ad: "Türkmenistan", dial: "+993", uzunluk: 8 },
  { ad: "Ukrayna", dial: "+380", uzunluk: 9 },
  { ad: "Yunanistan", dial: "+30", uzunluk: 10 },
];

export function ulkeBul(dial) {
  return ULKE_KODLARI.find((u) => u.dial === dial) || ULKE_KODLARI[0];
}
